import analyticsService from "./AnalyticsService";
import { ANALYTICS_EVENTS } from "./constants";

export const trackEvent = (eventName, params = {}, options = {}) => {
  analyticsService.track(eventName, params, options);
};

export const trackPageView = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.PAGE_VIEW, params);

export const trackSignUp = (params = {}) =>
  trackEvent(
    ANALYTICS_EVENTS.SIGN_UP,
    {
      interaction_type: "clicked",
      ...params,
    },
    { dedupe: false },
  );

export const trackSignIn = (params = {}) =>
  trackEvent(
    ANALYTICS_EVENTS.SIGN_IN,
    {
      interaction_type: "clicked",
      ...params,
    },
    { dedupe: false },
  );

export const trackSignOut = (params = {}) =>
  trackEvent(
    ANALYTICS_EVENTS.SIGN_OUT,
    {
      interaction_type: "clicked",
      ...params,
    },
    { dedupe: false },
  );

export const trackForgotPassword = (params = {}) =>
  trackEvent(
    ANALYTICS_EVENTS.FORGOT_PASSWORD,
    {
      interaction_type: "clicked",
      ...params,
    },
    { dedupe: false },
  );

export const trackClick = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.SELECT_ITEM, {
    interaction_type: "clicked",
    ...params,
  });

export const trackSelectedItem = (params = {}) => {
  trackEvent(ANALYTICS_EVENTS.SELECT_ITEM, {
    interaction_type: "selected",
    ...params,
  });
};

export const trackMenuItemSelected = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.MENU_ITEM_SELECTED, {
    interaction_type: "selected",
    ...params,
  });

export const trackApplyFilterInteraction = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.APPLY_FILTER, params);

export const trackChatbotInteraction = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.CHAT_BOT_INTERACTION, params, {
    interaction_type: "clicked",
  });

export const trackDownload = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.FILE_DOWNLOAD, params);

export const trackAPI = (params = {}) => analyticsService.trackAPI(params);

export const trackError = (params = {}) => analyticsService.trackError(params);

export const trackPerformance = (params = {}) =>
  analyticsService.trackPerformance(params);

export const trackDashboard = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.DASHBOARD_OPENED, params);

export const trackCardInteraction = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.CARD_VIEWED, params);

export const trackCardClickInteraction = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.CARD_CLICKED, params);

export const trackCardPopUpOpenedInteraction = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.CARD_POPUP_OPENED, params);

export const trackExport = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.EXPORT, params);

export const trackCardClicked = (params = {}) =>
  trackCardClickInteraction({
    ...params,
    interaction_type: "card_clicked",
  });

export const trackCardPopUpOpened = (params = {}) =>
  trackCardPopUpOpenedInteraction({
    ...params,
    interaction_type: "viewed",
  });

export const trackCardExpanded = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.CARD_EXPANDED, {
    ...params,
    interaction_type: "toggled",
  });

export const trackButtonClicked = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
    ...params,
    interaction_type: "clicked",
  });

export const trackApplyFilterClicked = (params = {}) =>
  trackApplyFilterInteraction({ ...params, interaction_type: "clicked" });

export const trackBenchmarkSelected = (params = {}) =>
  trackEvent("benchmark_selected", params);

export const trackTrendChanged = (params = {}) =>
  trackEvent("trend_changed", params);

export const trackSort = (params = {}) => trackEvent("sort", params);

export const trackTableSorted = (params = {}) =>
  trackSort({ target: "table", ...params });

export const trackScrollDepth = (params = {}) =>
  trackEvent("scroll_depth", params);